<div class="flex flex-column w-12 mx-0">
  <p-panel [toggleable]="true" [collapsed]="true">
    <ng-template pTemplate="header">
      <div class="text-center my-1" style="width: 92%">
        <span class="my-0 font-weight-normal"
          >Spatial Validation Summary Statistics</span
        >
      </div>
    </ng-template>
    <ng-template pTemplate="icons">
      <label
        class="p-panel-header-icon mb-0"
        pTooltip="Statistics of the spatial validation results."
        tooltipPosition="bottom"
      >
        <span class="pi pi-question-circle help-icon"></span>
      </label>
    </ng-template>

    @if (table$ | async; as table) {
      <div class="pb-3">
        @if (table === "error file size") {
          This validation has resulted in a file whose size exceeds the maximum
          limit.
        } @else {
          <span [innerHtml]="table" class="lg:text-base text-sm"></span>
          <div class="d-flex justify-content-between align-items-center mt-2">
            <button
              pButton
              type="button"
              icon="pi pi-download"
              label="Download statistics .zip"
              class="btn-action-large"
              pTooltip="Download spatial statistics"
              [life]="globals.tooltipLifetime"
              (click)="getSummaryStatisticsAsCsv()"
            ></button>
          </div>
        }
      </div>
    } @else {
      <p class="lead text-muted">
        We could not fetch spatial statistics. Please try again later.
      </p>
    }
  </p-panel>
</div>
